import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Secondary } from "@cinch-labs/design-system";
import { useViewport } from "@cinch-labs/shared-util";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import Image from "next/image";
import styles from "./shop-by-shape-card.module.css";
import Link from "next/link";
import { forwardRef } from "react";
var ShopByShapeCard = /*#__PURE__*/ forwardRef(function(param, ref) {
    var title = param.title, image = param.image, count = param.count, minSeats = param.minSeats, maxSeats = param.maxSeats, filterQuery = param.filterQuery, alt = param.alt;
    var trackEvent = useAnalytics().trackEvent;
    var handleClick = function() {
        trackEvent({
            eventName: "Shop by type: ".concat(title),
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "button",
                    label: "Shop by type",
                    action: title.toLowerCase()
                }
            }
        });
    };
    var vw = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    }).vw;
    var isMobile = vw < 1024;
    return /*#__PURE__*/ _jsx(Link, {
        href: "/used-cars/".concat(filterQuery),
        passHref: true,
        children: /*#__PURE__*/ _jsxs("a", {
            "data-testid": "shop-by-shape-card",
            className: styles["card"],
            onClick: handleClick,
            href: "/find-vehicle",
            ref: ref,
            children: [
                /*#__PURE__*/ _jsx(Image, {
                    src: image,
                    layout: "responsive",
                    width: 248,
                    height: 115,
                    alt: alt
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles["heading"],
                    children: [
                        /*#__PURE__*/ _jsx(Heading, {
                            element: "h4",
                            className: styles["title"],
                            children: title
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: styles["body"],
                            children: "".concat(minSeats, " - ").concat(maxSeats, " seats")
                        })
                    ]
                }),
                isMobile ? /*#__PURE__*/ _jsx("span", {
                    className: styles["link"],
                    children: "Shop ".concat(count, " cars")
                }) : /*#__PURE__*/ _jsx(Secondary, {
                    element: "span",
                    classNames: {
                        button: styles["button"]
                    },
                    "aria-label": "Shop by shape card",
                    children: "Shop ".concat(count, " cars")
                })
            ]
        })
    });
});
export default ShopByShapeCard;
